// Constants
import { Roles } from '@constants/Session';
import { ICompanyInformation } from '@models/Company';

export const checkIsSupport = (companyInformation: ICompanyInformation): boolean => {
    return companyInformation?.users?.some(user => user?.rol === Roles.SUPPORT) || false;
};
